// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  index: {
    operation: 'Руководство по эксплуатации',
    app_store: 'коммерческая лицензия',
    signin: 'Адрес доступа:',
    app_title: 'Название приложения',
    slogan: 'лозунг',
    server: 'запросить базовый URL',
    index_title: 'Платформа управления складами',
    webtitle: 'GreaterWMS--Система управления складом с открытым исходным кодом',
    home: 'титульная страница',
    title: 'GreaterWMS',
    title_tip: 'GreaterWMSтитульная страница',
    hide_menu: 'Свернуть меню',
    api: 'APIДокументация',
    translate: 'изменить язык',
    unread: 'Непрочитанное сообщение',
    login: 'авторизоваться',
    register: 'регистр',
    login_tip: 'Введите openid и имя пользователя',
    register_tip: 'Зарегистрироваться как администратор',
    logout: 'Бросить логин',
    user_login: 'Логин пользователя',
    admin_login: 'Логин администратора',
    return_to_login: 'Вернуться в логин',
    user_center: 'Центр пользователя',
    change_user: 'Сменить пользователя',
    view_my_openid: 'Просмотр моего OpenID ',
    your_openid: 'Ваш открытый',
    contact_list: 'Недавние контакты',
    chat_more: 'Больше истории сообщений',
    chat_no_more: 'Нет больше новостей',
    chat_send: 'Отправить',
    previous: 'Предыдущая страница',
    next: 'Следущая страница',
    admin_name: 'администратор',
    password: 'пароль',
    confirm_password: 'Подтвердите пароль',
    staff_name: 'имя пользователя',
    cancel: 'Отмена',
    close: 'закрытие',
    submit: 'Отправить',
    download: 'скачать',
    updatetitle: 'Обновление',
    updatedesc: 'Версия была обновлена ​​готов',
    update: 'Немедленно обновить',
    chart: 'Отчет',
    current_user: 'Текущий пользователь'
  },
  Settings: {
    index: 'Настройки',
    server: 'сервер',
    equipment: 'Поддержка оборудования'
  },
  menuItem: {
    dashboard: 'Панель инструментов',
    inbound: 'Входящий',
    outbound: 'Исходящий',
    stock: 'Инвентарь',
    finance: 'Финансы',
    goods: 'Список товаров',
    baseinfo: 'Базовая информация',
    warehouse: 'Склад',
    staff: 'Персонал',
    driver: 'Водитель',
    customerdn: 'DN клиента',
    supplierasn: 'ASN поставщика',
    uploadcenter: 'Центр загрузки',
    downloadcenter: 'Центр загрузки',
    cloudwarehouse: 'Складское соединение'
  },
  contact: '',
  sendmessage: 'Общаться сразу',
  send: 'Отправить',
  nomoremessage: 'Нет больше новостей',
  loadmore: 'Загрузи больше',
  new: 'Новый',
  newtip: 'Добавьте данные',
  refresh: 'Освежать',
  refreshtip: 'Обновить все данные',
  edit: 'Отредактируйте эти данные',
  confirmedit: 'Подтвердите редактирование данных',
  canceledit: 'Отменить редактирование данных',
  delete: 'Удалить эти данные',
  deletetip: 'Эта операция необратима。',
  confirmdelete: 'Подтвердите удаление данных',
  canceldelete: 'Отмена удаления данных',
  download: 'скачать',
  downloadtip: 'Скачать все данные',
  frombin: 'Положение из библиотеки',
  movetobin: 'Перечислить',
  putaway: 'На полках',
  cyclecount: 'Динамический инвентарь',
  cyclecountrecorder: 'Запись инвентаря',
  search: 'Поиск по ключевым словам',
  creater: 'основатель',
  createtime: 'Создать время',
  updatetime: 'Время обновления',
  action: 'действовать',
  previous: 'Предыдущая страница',
  next: 'Следущая страница',
  no_data: 'Нет больше данных',
  submit: 'подтверждать',
  cancel: 'Отмена',
  estimate: 'Оценить доставку',
  downloadasnlist: 'Список загрузки',
  downloadasndetail: 'Скачать детали',
  downloadasnlisttip: 'Загрузите список уведомлений',
  downloadasndetailtip: 'Загрузка Прибытие Уведомление',
  printthisasn: 'Просмотр уведомления о доставке',
  confirmdelivery: 'Подтвердите, что вы прибыли',
  finishloading: 'Подтвердите завершение разгрузки',
  confirmsorted: 'Убедитесь, что сортировка завершена',
  downloaddnlist: 'Список загрузки',
  downloaddndetail: 'Скачать детали',
  downloaddnlisttip: 'Загрузить список отгрузки',
  downloaddndetailtip: 'Скачать заказ доставки',
  release: 'Заказ сопоставления',
  releaseallorder: 'Все заказывают заказы сборки',
  releaseorder: 'Выбор заказов',
  print: 'Список выбора печати',
  printthisdn: 'Просмотр и распечатать корабль',
  confirmorder: 'Подтвердить заказ',
  confirmpicked: 'Подтвердите завершению выбора',
  dispatch: 'Загрузка',
  deletebackorder: 'Удалить заказы на товары',
  confirminventoryresults: 'Подтвердите результаты инвентаризации',
  baseinfo: {
    company_info: 'Информация о компании',
    supplier: 'поставщик',
    customer: 'клиент',
    view_company: {
      company_name: 'название компании',
      company_city: 'Город',
      company_address: 'адрес',
      company_contact: 'Контакты',
      company_manager: 'главный',
      error1: 'Пожалуйста, введите название компании',
      error2: 'Пожалуйста, введите город, где находится компания',
      error3: 'Пожалуйста, введите адрес компании',
      error4: 'Пожалуйста, введите компанию Контакт',
      error5: 'Пожалуйста, введите ответственное лицо компании'
    },
    view_supplier: {
      supplier_name: 'Наименование поставщика',
      supplier_city: 'Город',
      supplier_address: 'адрес',
      supplier_contact: 'Контакты',
      supplier_manager: 'главный',
      supplier_level: 'Уровень поставщика',
      error1: 'Пожалуйста, введите имя поставщика',
      error2: 'Пожалуйста, введите город, где расположен поставщик',
      error3: 'Пожалуйста, введите адрес поставщика',
      error4: 'Пожалуйста, введите вашу контактную информацию',
      error5: 'Пожалуйста, введите личность поставщика',
      error6: 'Пожалуйста, введите уровень поставщика'
    },
    view_customer: {
      customer_name: 'Имя клиента',
      customer_city: 'Город',
      customer_address: 'адрес',
      customer_contact: 'Контакты',
      customer_manager: 'главный',
      customer_level: 'Уровень клиента',
      error1: 'Пожалуйста, введите имя клиента',
      error2: 'Пожалуйста, введите город, где клиент находится',
      error3: 'Пожалуйста, введите адрес клиента',
      error4: 'Пожалуйста, введите контакт',
      error5: 'Пожалуйста, введите руководитель клиентов',
      error6: 'Пожалуйста, введите уровень клиента'
    }
  },
  dashboards: {
    outbound_statements: 'Торговая точка',
    inbound_statements: 'Доклад квитанции',
    inbound_and_outbound_statements: 'Доклад на корабле',
    total_sales: 'Тотальная распродажа',
    category_sales_ranking: 'Категория Рейтинги по продажам',
    sales_volume_ranking: 'Рейтинги по продажам',
    sales_volumes_ranking: 'Рейтинг количества продаж',
    total_receipts: 'Общая квитанция',
    category_receipt_ranking: 'Категория Прием рейтинга',
    receiving_quantity_ranking: 'Рейтинг квитанции',
    Receiving_amount_ranking: 'Прием рейтинга',
    view_tradelist: {
      mode_code: 'Средства транзакции',
      bin_name: 'Название случая',
      goods_code: 'Код товара',
      goods_qty: 'Существующее количество',
      creater: 'основатель',
      update_time: 'Время обновления',
      create_time: 'Создать время',
      inbound: 'Квитанция',
      outbound: 'Судно'
    }
  },
  finance: {
    capital: 'Фиксированный актив',
    freight: 'Управление грузом',
    view_capital: {
      capital_name: 'Исправлено имя актива',
      capital_qty: 'количество',
      capital_cost: 'Количество',
      error1: 'Пожалуйста, введите название актива',
      error2: 'Количество активов должно быть больше 0',
      error3: 'Количество активов должно быть больше 0'
    },
    view_freight: {
      transportation_supplier: 'Перевозчик',
      send_city: 'Происходить',
      receiver_city: 'Город прибытия',
      weight_fee: 'Одиночная плата за килогрей',
      volume_fee: 'Одиночный кубический счетчик доставки',
      min_payment: 'Минимальная доставка',
      error1: 'Пожалуйста, введите перевозчик',
      error2: 'Пожалуйста, введите город',
      error3: 'Пожалуйста, введите город',
      error4: 'Одиночные килограммы груза должны быть больше 0',
      error5: 'Одиночные кубические метры груза должны быть больше 0',
      error6: 'Минимальная стоимость доставки должна быть больше 0'
    }
  },
  driver: {
    driver: 'Управление драйверами',
    dispatchlist: 'Пикап записи',
    error1: 'Пожалуйста, введите имя драйвера',
    error2: 'Пожалуйста, введите номер номерного знака',
    error3: 'Пожалуйста, введите контакт',
    view_driver: {
      driver_name: 'Имя водителя',
      license_plate: 'номерной знак',
      contact: 'Контакты'
    },
    view_dispatch: {
      driver_name: 'Имя водителя',
      dn_code: 'Номер заказа заказа',
      contact: 'Контакты'
    }
  },
  upload_center: {
    initializeupload: 'Инициализация загрузки',
    uploadfiles: 'загрузить файлы',
    upload: 'Загрузить',
    uploadcustomerfile: 'Загрузить список клиентов',
    uploadgoodslistfile: 'Загрузіць спіс формы прадукту',
    uploadsupplierfile: 'Загрузіць спіс пастаўшчыкоў',
    downloadgoodstemplate: 'Спампаваць шаблон прадукту',
    downloadcustomertemplate: 'Спампаваць шаблон кліента',
    downloadsuppliertemplate: 'Спампаваць шаблон пастаўшчыка',
    addupload: 'Дадаць загрузку'
  },
  download_center: {
    createTime: 'ствары час',
    reset: 'скід',
    start: 'Пачаць',
    end: 'Завяршыць'
  },
  community_mall: {
    communitymall: 'Community Mall'
  },
  goods: {
    goods_list: 'Спіс прадуктаў',
    unit: 'Таварная адзінка',
    class: 'Катэгорыя тавару',
    color: 'колер прадукту',
    brand: 'брэнд прадукту',
    shape: 'Форма прадукту',
    specs: 'Спецыфікацыі прадукту',
    origin: 'Паходжанне прадукту',
    view_goodslist: {
      goods_code: 'Код тавару',
      goods_desc: 'Апісанне Прадукта',
      goods_name: 'назва прадукту',
      goods_supplier: 'пастаўшчык',
      goods_weight: 'Вага тавару (адзінка: грам)',
      goods_w: 'Даўжыня элемента (адзінка: мм)',
      goods_d: 'Шырыня прадукту (адзінка: мм)',
      goods_h: 'Вышыня тавару (адзінка: мм)',
      unit_volume: "'Мінімальны аб'ём адзінкі'",
      goods_unit: 'Таварная адзінка',
      goods_class: 'Катэгорыя тавару',
      goods_brand: 'брэнд прадукту',
      goods_color: 'колер прадукту',
      goods_shape: 'Форма прадукту',
      goods_specs: 'Спецыфікацыі прадукту',
      goods_origin: 'Паходжанне прадукту',
      goods_cost: 'Кошт тавару',
      goods_price: 'Цана на тавар',
      print_goods_label: 'Друк этыкеткі прадукту',
      error1: 'Калі ласка, увядзіце код прадукту',
      error2: 'Калі ласка, увядзіце апісанне прадукту',
      error3: 'Калі ласка, увядзіце пастаўшчыка прадукту',
      error4: 'Вага элемента павінна быць больш за 0',
      error5: 'Даўжыня элемента павінна быць большай за 0',
      error6: 'Шырыня прадукту павінна быць большай за 0',
      error7: 'Вышыня прадукту павінна быць большай за 0',
      error8: 'Калі ласка, увядзіце кошт тавару',
      error9: 'Калі ласка, увядзіце цану прадукту'
    },
    view_unit: {
      goods_unit: 'Таварная адзінка',
      error1: 'Калі ласка, увядзіце адзінку прадукту'
    },
    view_class: {
      goods_class: 'Катэгорыя тавару',
      error1: 'Калі ласка, увядзіце катэгорыю прадукту'
    },
    view_color: {
      goods_color: 'колер прадукту',
      error1: 'Калі ласка, увядзіце колер прадукту'
    },
    view_brand: {
      goods_brand: 'брэнд прадукту',
      error1: 'Калі ласка, увядзіце марку прадукту'
    },
    view_shape: {
      goods_shape: 'Форма прадукту',
      error1: 'Калі ласка, увядзіце форму прадукту'
    },
    view_specs: {
      goods_specs: 'Спецыфікацыі прадукту',
      error1: 'Калі ласка, увядзіце спецыфікацыі прадукту'
    },
    view_origin: {
      goods_origin: 'Паходжанне прадукту',
      error1: 'Калі ласка, увядзіце паходжанне прадукту'
    }
  },
  inbound: {
    asn: 'Паведамленне аб прыбыцці',
    predeliverystock: 'прыязджаць',
    preloadstock: 'Каб разгрузіць',
    presortstock: 'падпарадкаваць',
    sortstock: 'сартаваць',
    shortage: 'Не хапае паступаючых тавараў',
    more: 'Больш прыбылых',
    asnfinish: 'Падрабязнасці квітанцыі',
    asndone: 'Квітанцыя завершана',
    view_sortstock: {
      error1: 'Калі ласка, увядзіце колькасць, колькасць павінна быць большай за 0'
    },
    view_asn: {
      asn_code: 'Нумар паведамлення аб прыбыцці',
      asn_status: 'Стан паведамлення аб прыбыцці',
      goods_qty: 'Колькасць паведамленняў аб прыбыцці',
      goods_actual_qty: 'Фактычная колькасць прыбыцця',
      goods_shortage_qty: 'Прыбыў у кароткай колькасці',
      goods_more_qty: 'Вялікая колькасць прыбыцця',
      goods_damage_qty: 'Колькасць пашкоджаных прыбыццяў',
      presortstock: 'Нумар для сартыроўкі',
      sorted_qty: 'Колькасць на складзе',
      total_weight: 'Агульная вага (адзінка: кг)',
      total_volume: "'Агульны аб'ём (адзінка: кубічны метр)'"
    }
  },
  outbound: {
    dn: 'Рахунак-фактура',
    freshorder: 'Папярэдні рахунак-фактура',
    neworder: 'Новы рахунак-фактура',
    backorder: 'Незаказы',
    pickstock: 'абраць',
    pickedstock: 'Абраныя',
    pickinglist: 'Падрабязнасці спісу выбару',
    shippedstock: 'Дастаўлена',
    received: 'Атрыманы',
    pod: 'Падпішыце квітанцыю',
    view_dn: {
      dn_code: 'нумар адпраўлення',
      dn_status: 'Статус рахунка-фактуры',
      goods_qty: 'колькасць замовы',
      intransit_qty: 'Колькасць адпраўлена',
      delivery_actual_qty: 'Фактычная колькасць прыбыцця',
      delivery_shortage_qty: 'Кароткае прыбыццё',
      delivery_more_qty: 'Больш прыбылых',
      delivery_damage_qty: 'Прыбыў пашкоджаным',
      total_weight: 'Агульная вага (адзінка: кг)',
      total_volume: "'Агульны аб'ём (адзінка: кубічны метр)'",
      customer: 'заказчык'
    }
  },
  staff: {
    staff: 'Спіс супрацоўнікаў',
    check_code: 'Код верыфікацыі',
    view_staff: {
      staff_name: 'імя супрацоўніка',
      staff_type: 'тып супрацоўніка',
      error1: 'Калі ласка, увядзіце імя супрацоўніка',
      error2: 'Калі ласка, увядзіце тып супрацоўніка',
      lock: 'блакіроўка',
      unlock: 'разблакіраваць'
    }
  },
  stock: {
    stocklist: 'спіс акцый',
    stockbinlist: 'Спіс месцазнаходжанняў',
    emptybin: 'Пустае месца',
    occupiedbin: 'Месца на складзе',
    view_stocklist: {
      goods_code: 'Код тавару',
      goods_desc: 'Апісанне Прадукта',
      goods_qty: 'Агульная сума',
      onhand_stock: 'Колькасць на руках',
      can_order_stock: 'Колькасць, якую можна размясціць',
      ordered_stock: 'Колькасць зробленых заказаў',
      inspect_stock: 'Колькасць кантролю якасці',
      hold_stock: 'Заблакіраваная колькасць',
      damage_stock: 'Разрыўная колькасць',
      asn_stock: 'Колькасць паведамленняў аб прыбыцці',
      dn_stock: 'Колькасць рахунка-фактуры',
      pre_load_stock: 'Колькасць для збору',
      pre_sort_stock: 'Нумар для сартыроўкі',
      sorted_stock: 'Сартаваны запас',
      pick_stock: 'Колькасць прадметаў для выбару',
      picked_stock: 'Абраная колькасць',
      back_order_stock: 'Колькасць тавару запазычанасці',
      on_hand_inventory: 'існыя акцыі',
      history_inventory: 'У наяўнасці на той момант',
      physical_inventory: 'Падлік колькасці',
      difference: 'розніца',
      cyclecount: 'Дынамічная інвентарызацыя',
      recyclecount: 'Скід',
      downloadcyclecount: 'Інвентарны спіс',
      cyclecountresult: 'праверыць вынікі',
      cyclecounttip: 'Стварыць дынамічную табліцу інвентарызацыі',
      recyclecounttip: 'Стварыць кантрольны спіс папаўнення запасаў',
      downloadcyclecounttip: 'Спампаваць кантрольны спіс',
      cyclecountresulttip: 'Пацвердзіць вынік падліку',
      daychoice: 'Выбар даты',
      daychoicetip: 'Выберыце табліцу інвентарызацыі, якая адпавядае даце',
      error1: 'Колькасць падлікаў павінна быць больш за 0',
      dateerror: 'Няправільная дата абраная'
    }
  },
  warehouse: {
    warehouse: 'Настройкі склада',
    binset: 'Настройка размяшчэння запасаў',
    binsize: 'Памер запасу',
    property: 'Уласцівасць размяшчэння',
    printbin: 'Надрукаваць метку месцазнаходжання',
    view_warehouseset: {
      error1: 'Калі ласка, увядзіце назву склада',
      error2: 'Калі ласка, увядзіце горад, дзе знаходзіцца склад',
      error3: 'Калі ласка, увядзіце адрас склада',
      error4: 'Калі ласка, увядзіце кантактную інфармацыю склада',
      error5: 'Калі ласка, увядзіце асобу, якая адказвае за склад'
    },
    view_warehouse: {
      warehouse_name: 'назва склада',
      warehouse_city: 'Горад размяшчэння',
      warehouse_address: 'адрас',
      warehouse_contact: 'Кантактная інфармацыя',
      warehouse_manager: 'дырэктар',
      square_measure: 'Доступная площадь',
      city_search: 'Городской поиск',
      publish_warehouse: 'Выпуск склада',
      Nopublish_warehouse: 'Отзыв склада'
    },
    view_binset: {
      bin_name: 'Назва месцазнаходжання',
      bin_size: 'Памер запасу',
      bin_property: 'Уласцівасць размяшчэння',
      empty_label: 'Пусты ідэнтыфікатар месцазнаходжання',
      error1: 'Калі ласка, увядзіце назву месца',
      error2: 'Калі ласка, увядзіце памер месцазнаходжання',
      error3: 'Калі ласка, увядзіце атрыбут месцазнаходжання'
    },
    view_binsize: {
      bin_size: 'Памер запасу',
      bin_size_w: 'Даўжыня запасу (адзінка: мм)',
      bin_size_d: 'Шырыня запасу (адзінка: мм)',
      bin_size_h: 'Вышыня запасу (адзінка: мм)',
      error1: 'Калі ласка, увядзіце памер месцазнаходжання',
      error2: 'Даўжыня месца захоўвання павінна быць большай за 0',
      error3: 'Шырыня запасу павінна быць большай за 0',
      error4: 'Вышыня запасу павінна быць большай за 0'
    },
    view_property: {
      bin_property: 'Уласцівасці размяшчэння акцый'
    }
  },
  scan: {
    scan: 'сканаванне',
    scan_asn: 'запыт ASN',
    scan_dn: 'DN-запыт',
    scan_sorting: 'сарціроўка',
    scan_uptobin: 'на паліцы',
    scan_picking: 'выбар',
    scan_shipping: 'Пагрузка і дастаўка',
    scan_movetobin: 'Перадача',
    scan_inventory: 'інвентар',
    scan_goodsquery: 'Запыт грузу',
    scan_locationquery: 'Запыт аб размяшчэнні запасаў',
    scan_goods_code: 'Код тавару',
    scan_bin_name: 'Назва месцазнаходжання',
    scan_goods_label: 'Этыкетка тавару',
    scan_goods_label_error: 'Этыкетка прадукту не існуе',
    view_binmove: {
      old_bin_name: 'Зыходная назва месцазнаходжання',
      new_bin_name: 'Новае імя скрыні',
      qty: 'Колькасць перамешчаных бібліятэк',
      qty_error: 'Колькасць для перамяшчэння не можа быць большай за існуючую колькасць'
    },
    view_upToBin: {
      goods_actual_qty: 'Фактычная колькасць прыбыцця',
      scan_qty: 'Колькасць адсканаваных',
      scan_qty_error: 'Колькасць сканавання не можа быць большай за колькасць прыбыцця'
    },
    view_picking: {
      order_qty: 'колькасць замовы',
      picking_qty: 'Выберыце колькасць',
      picking_qty_error: 'Колькасць камплектавання не можа быць большай за колькасць замовы'
    },
    view_shipping: {
      shipping_code: 'нумар адпраўлення',
      driver_info: 'інфармацыя драйвера',
      license_plate_number: 'Номарны нумар',
      name: 'імя',
      contact_info: 'Кантактная інфармацыя'
    }
  },
  handcount: {
    handcount: 'Одиночный счет',
    handcountrecorder: 'Однократный регистратор',
    update_time: 'Считать время'
  },
  notice: {
    valerror: 'Калі ласка, увядзіце правільнае значэнне',
    unknow_error: 'Невядомая памылка',
    network_error: 'Выключэнне сеткі',
    nullerror: '',
    cyclecounterror: 'Няма дадзеных',
    userererror: 'Імя карыстальніка ўжо існуе',
    capitalerror: 'Назва асноўных сродкаў ужо існуе',
    valuenullerror: 'Калі ласка, запоўніце поўныя дадзеныя',
    loginerror: 'Калі ласка, увайдзіце спачатку',
    goodserror: {
      goods_listerror: 'Код прадукту ўжо існуе',
      goods_uniterror: 'Таварная адзінка ўжо існуе',
      goods_classerror: 'Катэгорыя тавараў ужо існуе',
      goods_colorerror: 'Колер тавару ўжо існуе',
      goods_branderror: 'Брэнд прадукту ўжо існуе',
      goods_shapeerror: 'Форма тавару ўжо існуе',
      goods_specserror: 'Спецыфікацыя тавару ўжо існуе',
      goods_originerror: 'Паходжанне тавару ўжо існуе'
    },
    baseinfoerror: {
      companyerror: 'Назва кампаніі ўжо існуе',
      customererror: 'Імя кліента ўжо існуе',
      suppliererror: 'Назва пастаўшчыка ўжо існуе'
    },
    warehouseerror: {
      binseterror: 'Імя bin ужо існуе',
      binsizeerror: 'памер скрыні ўжо існуе'
    },
    mobile_userlogin: {
      notice1: 'Пожалуйста, введите имя администратора',
      notice2: 'Пожалуйста, введите пароль администратора',
      notice3: 'Пожалуйста, введите имя вашего сотрудника',
      notice4: 'Пожалуйста, введите код проверки персонала',
      notice5: 'Пожалуйста, введите свой OpenID в настройках сервера',
      notice6: 'Успешный вход в систему',
      notice7: 'Пользователь или пароль не выделены',
      notice8: 'Персонал или код проверки не выделены'
    },
    mobile_scan: {
      notice1: 'QR-код не существует',
      notice2: 'Код не существует',
      notice3: 'Ошибка сервера',
      notice4: 'Только мобильный телефон может сканировать'
    },
    mobile_asn: {
      notice1: 'Список ASN',
      notice2: 'Вы можете отсканировать QR-код уведомления о прибытии или щелкнуть noticeо прибытии, чтобы просмотреть детали уведомления о прибытии и начать работу',
      notice3: 'Поставщик:',
      notice4: 'Общая сумма:',
      notice5: 'Статус:',
      notice6: 'Подробности уведомления о прибытии',
      notice7: 'Вам необходимо отсканировать noticeо прибытии, чтобы получить подробную информацию об уведомлении о прибытии. Вы можете отсканировать код груза или нажать на товары, которые хотите разместить на полках, чтобы завершить операцию с товарами на полках',
      notice8: 'Подробности',
      notice9: 'Общая сумма:',
      notice10: 'Номер для указания:',
      notice11: 'Количество объявлений должно быть больше 0',
      notice12: 'Успешный листинг',
      notice13: 'Пожалуйста, введите код местоположения'
    },
    mobile_dn: {
      notice1: 'Список DN',
      notice2: 'Вы можете отсканировать QR-код заказа DN или щелкнуть заказ DN, чтобы просмотреть сведения о DN и выполнить операции',
      notice3: 'Клиент:',
      notice4: 'Общая сумма:',
      notice5: 'Статус:',
      notice6: 'Детали DN',
      notice7: 'Подробности DN - это все счета-фактуры. Отсканируйте номер DN, чтобы просмотреть сведения о конкретном DN',
      notice8: 'Подробности',
      notice9: 'Общая сумма:',
      notice10: 'Количество счетов:',
      notice11: 'Все детали списка выбора находятся здесь, вы также можете отсканировать конкретные товары или DN, чтобы получить список выбора для работы',
      notice12: 'Пожалуйста, введите конкретное количество комплектации',
      notice13: 'Успешный выбор',
      notice14: 'Имя бина:',
      notice15: 'Количество, которое нужно выбрать:'
    },
    mobile_goodsstock: {
      notice1: 'Список запасов',
      notice2: 'Здесь вы можете увидеть всю информацию об инвентаре, нажмите, чтобы просмотреть информацию об инвентаре напрямую',
      notice3: 'На складе:',
      notice4: 'Может быть заказан запас:'
    },
    мобильный_бинсток: {
      notice1: 'Список складских запасов',
      notice2: 'Здесь вы можете просмотреть информацию о запасах всех складских помещений, щелкнуть, чтобы получить прямой доступ к запасам склада, выполнить операцию перемещения склада или отсканировать товары, чтобы проверить состояние хранения всех товаров',
      notice3: 'Имя бина:',
      notice4: 'Объем хранилища:',
      notice5: 'Пожалуйста, введите имя корзины',
      notice6: 'Репозиторий успешно перемещен'
    },
    mobile_emptybin: {
      notice1: 'Пустой список корзин',
      notice2: 'Здесь вы можете увидеть все пустые локации',
      notice3: 'Свойство складской корзины:'
    },
    equipment: {
       notice1: 'Список поддерживаемого оборудования',
       notice2: 'Здесь перечислены все бренды устройств и системы, поддерживаемые приложением'
     },
    handcount: {
      notice1: 'Подробности',
      notice2: 'Ручной подсчет',
      notice3: 'На складе',
      notice4: 'Подсчитать количество',
      notice5: 'Подтвердить результат',
      notice6: 'Подтвердить результат подсчета',
      notice7: 'Успешный подтвержденный результат подсчета',
      notice8: 'Здесь показаны детали товаров, которые необходимо пересчитать'
    },
    400: 'Дрэнны запыт (400)',
    401: 'Несанкцыянавана (401)',
    403: 'Доступ забаронены (403)',
    404: 'Рэссурс не існуе (404)',
    405: 'Гэта функцыя адключана (405)',
    408: 'Тайм-аўт запыту (408)',
    409: 'Канфлікт даных (409)',
    410: 'Даныя выдалены (410)',
    500: 'Памылка сервера (500)',
    501: 'Служба не рэалізавана (501)',
    502: 'Памылка сеткі (502)',
    503: 'Служба недаступная (503)',
    504: 'Тайм-аўт сеткі (504)',
    505: 'Версія HTTP не падтрымліваецца (505)'
  }
}
